// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__3Xfwj","imgWrapper":"styles_imgWrapper__2E_sn","bottomButtonWrapper":"styles_bottomButtonWrapper__3_M3G"};